"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var CheckboxGroup_1 = require("./CheckboxGroup");
var i18n_1 = require("@wordpress/i18n");
var hooks_1 = require("preact/hooks");
var compat_1 = require("preact/compat");
var ProjectExperience = (0, compat_1.forwardRef)(function ProjectExperience(props, ref) {
    var project = props.project, onMount = props.onMount;
    var hasAddons = project && project.addons && project.addons.length > 0;
    (0, hooks_1.useEffect)(function () {
        if (typeof onMount === 'function') {
            onMount(ref);
        }
    });
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: hasAddons && ((0, jsx_runtime_1.jsxs)("div", __assign({ ref: ref }, { children: [(0, jsx_runtime_1.jsxs)("h2", __assign({ className: "appform-heading-2" }, { children: [" ", (0, i18n_1.__)("Add experience", "projects-abroad")] })), (0, jsx_runtime_1.jsx)(CheckboxGroup_1.default, { name: "addons[]", options: project.addons.map(function (addon) { return ({
                        id: addon.id,
                        name: addon.name,
                        price: "+" + addon.priceFormatted,
                    }); }) })] }))) }));
});
exports.default = ProjectExperience;
